import React, { useState } from "react";
import type { CSSProperties, ReactNode } from "react";

interface PdfPageSurfaceProps {
  className?: string;
  style: CSSProperties;
  children: (isRendered: boolean) => ReactNode;
}

/** Wait for the PDF page image, rather than faster-loading overlay content. */
export function PdfPageSurface({
  className,
  style,
  children,
}: PdfPageSurfaceProps) {
  const [isRendered, setIsRendered] = useState(false);

  return (
    <div
      className={className}
      style={style}
      onLoadCapture={(event) => {
        const image = event.target;
        if (
          image instanceof HTMLImageElement &&
          image.dataset.pdfPageImage === "true"
        ) {
          setIsRendered(true);
        }
      }}
    >
      {children(isRendered)}
    </div>
  );
}
